module.exports = __webpack_public_path__ + "static/media/user.085f3ce4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/menu/user.svg
// module id = 61
// module chunks = 0